module.exports = __webpack_public_path__ + "static/media/gb.50f7fd14.svg";